import { useSelector } from "react-redux";
export const useAppSelector = useSelector;
export const useRootSelector = () => useAppSelector((state) => state.root);
export const useLockScreenSelector = () => useAppSelector((state) => state.lockScreen);
export const useNotificationsSelector = () => useAppSelector((state) => state.notifications);
